import React from "react";
import { useNavigate } from "react-router-dom";
import "../styles/RoleSelection.css";
import { FaUserTie, FaUser } from "react-icons/fa"; 

function RoleSelectionPage() {
  const navigate = useNavigate();

  {/*const handleRoleSelect = (role) => {
    if (role === "recruiter") {
      navigate("/recruiter-onboarding");
    } else if (role === "candidate") {
      navigate("/candidate-onboarding");
    }
  };*/}

  // added on 11-12-2025
  const handleRoleSelect = async (role) => {
 // const token = localStorage.getItem("access_token");
  const token = localStorage.getItem("access_token") 
      //  localStorage.getItem("access_token");

    console.log("TOKEN SENT TO BACKEND:", token);

  //const res = await fetch("http://144.91.102.67:8001/auth/update-role",
  const res = await fetch("/api/auth/update-role",
     {
    method: "PUT",
     mode: "cors",    // ← ADD THIS
    headers: {
      "Content-Type": "application/json",
      Authorization: "Bearer " + token
    },
    body: JSON.stringify({ role })
  });

    if (!res.ok) {
     const msg = await res.text();
    console.error("❌ ROLE UPDATE FAILED:", res.status, msg);  
    alert("Error updating role");
    return;
  }

   const data = await res.json();
  localStorage.setItem("access_token", data.access_token);

  //.then(res => res.json())
  //.then(data => {
    //localStorage.setItem("access_token", data.access_token);
  //});

  if (role === "recruiter")
    navigate("/recruiter-onboarding");
  else
    navigate("/candidate-onboarding");
};

  return (
    <div className="role-selection">
      <h1>Select Your Role</h1>
      <div className="role-cards">
        <div className="role-card" onClick={() => handleRoleSelect("recruiter")}>
          <FaUserTie size={60} color="#4a90e2" />

          <h2>Recruiter</h2>
          <p>Post jobs and manage listings</p>
        </div>
        <div className="role-card" onClick={() => handleRoleSelect("candidate")}>
          <FaUser size={60} color="#f39c12" />
          <h2>Candidate</h2>
          <p>Browse and apply for jobs</p>
        </div>
      </div>
    </div>
  );
}

export default RoleSelectionPage;
